import {
  CUSTOM_REPORT_VALIDATE,
  CUSTOM_REPORT_EXECUTE,
  CUSTOM_REPORT_SAVE,
  CUSTOM_REPORT_LIST,
  CUSTOM_REPORT_GET,
  CUSTOM_REPORT_UPDATE,
  CUSTOM_REPORT_DELETE,
  CUSTOM_REPORT_SCHEMA,
  CUSTOM_REPORT_EXPORT_EXCEL,
  CUSTOM_REPORT_EXPORT_PDF,
} from "../types";

export const customReportValidateAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_REPORT_VALIDATE,
    data,
    onSuccess,
    onError,
  };
};

export const customReportExecuteAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_REPORT_EXECUTE,
    data,
    onSuccess,
    onError,
  };
};

export const customReportSaveAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_REPORT_SAVE,
    data,
    onSuccess,
    onError,
  };
};

export const customReportListAction = (onSuccess, onError) => {
  return {
    type: CUSTOM_REPORT_LIST,
    onSuccess,
    onError,
  };
};

export const customReportGetAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_REPORT_GET,
    data,
    onSuccess,
    onError,
  };
};

export const customReportUpdateAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_REPORT_UPDATE,
    data,
    onSuccess,
    onError,
  };
};

export const customReportDeleteAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_REPORT_DELETE,
    data,
    onSuccess,
    onError,
  };
};

export const customReportSchemaAction = (onSuccess, onError) => {
  return {
    type: CUSTOM_REPORT_SCHEMA,
    onSuccess,
    onError,
  };
};

export const customReportExportExcelAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_REPORT_EXPORT_EXCEL,
    data,
    onSuccess,
    onError,
  };
};

export const customReportExportPdfAction = (data, onSuccess, onError) => {
  return {
    type: CUSTOM_REPORT_EXPORT_PDF,
    data,
    onSuccess,
    onError,
  };
};
